<div class="row">
  <div class="col-md-6">
    <span *ngIf="customer.customer_Address1" class="form-inline">
      <span class="text-bidit-primary">{{customer.customer_Address1}},{{customer.customer_Address2}}</span>
    </span>
    <div class="form-inline">
      <span class="text-bidit-primary">{{customer.customer_City}}, {{customer.customer_State}} {{customer.customer_Postal}}</span>
    </div>
    <div *ngIf="customer.mainContact" class="form-inline">
      <span for="mainContactName" class="text-bidit-primary">Contact:</span>
      <span id="mainContactName" class="text-bidit-primary">{{customer.mainContact?.contact_FirstName}} {{customer.mainContact?.contact_LastName}}</span>
    </div>
    <div *ngIf="customer.mainContact?.contact_Mobile" class="form-inline">
      <label for="mainContactMobile" class="text-bidit-primary">Cell Phone:</label>
      <div id="mainContactMobile" class="text-bidit-primary" href="tel:{{customer.mainContact?.contact_Mobile}}">{{customer.mainContact?.contact_Mobile}}</div>
    </div>
    <div class="">
      <small class="text-bidit-primary">{{customer.mainContact?.contact_Email}}</small>
    </div>
  </div>
  <div class="col-md-6">
    <div class="form-inline">
      <span class="text-bidit-primary">
        {{customerType?.customerType_Desc}}
      </span>
    </div>
    <div *ngIf="customer.office?.office_Name" class="form-inline">
      <label for="office_ID" class="text-bidit-primary">Office:</label>
      <span class="text-bidit-primary">{{customer.office?.office_Name}}</span>
    </div>
    <div class="form-inline">
      <label for="salesPersonName" class="text-bidit-primary">Salesperson:</label>
      <span id="salesPersonName" class="text-bidit-primary">{{customer.assignedTo?.firstName}} {{customer.assignedTo?.lastName}}</span>
    </div>
    <div class="form-inline">
      <label for="customer_CreatedBy" class="text-bidit-primary">Created By:</label>
      <span id="customer_CreatedBy" class="text-bidit-primary">{{customer.createdBy?.firstName}} {{customer.createdBy?.lastName}} </span>
    </div>
    <div class="form-inline">
      <label for="customer_Created" class="text-bidit-primary">Date:</label>
      <span id="customer_Created" class="text-bidit-primary">{{customer.customer_Created  | date: 'M/d/yyyy'}}</span>
    </div>
  </div>
</div>
